import React from "react";
import "./AboutComponent.css"
import about_img from "../../Images/about-image.png"
import sub_text_icon from "../../Images/gre-aa.png"
import arrow_icon from "../../Images/Icon.png"
import { Link } from "react-router-dom";
import man_img from "../../Images/men-img.png"


const AboutComponent = () => {
 
  return (
    <div className="troo-da-about-section" id="troo-da-about-section">
      <div className="galaxy">
        <div className="mercury"></div>
        <div className="orbit-mercury"></div>
      </div>
      <div className="container">
        <div className="row">
          <div className="col-md-6">
            <div className="about-left-img">
              <img src={about_img} alt="about_img" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="about-text">
              <div className="sub-title">
                <div className="text-sub">
                  <img className="up" src={sub_text_icon} alt="sub_text_icon" />
                  Little about usy
                </div>
                <div className="title">
                  <h2>
                    <span>
                      We working for you to build your <br />
                    </span>
                    business fast
                  </h2>
                </div>
              </div>
              <p>
                Lorem Ipsum is simply dummy text of the printing and typesetting
                industry. Lorem Ipsum has been the industry's standard dummy
                text ever since the 1500s, when an unknown printer too.
              </p>
              <ul>
                <li>
                  <img src={arrow_icon} alt="arrow_icon" />
                  <span>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy.
                  </span>
                </li>
                <li>
                  <img src={arrow_icon} alt="arrow_icon"/>
                  <span>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy.
                  </span>
                </li>
                <li>
                  <img src={arrow_icon} alt="arrow_icon" />
                  <span>
                    Lorem Ipsum is simply dummy text of the printing and
                    typesetting industry. Lorem Ipsum has been the industry's
                    standard dummy.
                  </span>
                </li>
              </ul>
              <div className="get-col">
                <Link to="/Home/About_Us"  >Learn More</Link>
              </div>
              <div className="clinet-ss">
                <div className="cl-img">
                  <img src={man_img} alt="man_img"/>
                </div>
                <div className="cl-tx">
                  <strong>Navil Williams</strong>
                  <span>Founder and CEO</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="arrowAnim">
        <div className="arrowSliding">
          <div className="arrow"></div>
        </div>
        <div className="arrowSliding delay1">
          <div className="arrow"></div>
        </div>
        <div className="arrowSliding delay2">
          <div className="arrow"></div>
        </div>
        <div className="arrowSliding delay3">
          <div className="arrow"></div>
        </div>
      </div>
    </div>
  );
};

export default AboutComponent;
